import React from 'react';
import PropTypes from 'prop-types';
import styles from './monitor.css';
import trophy from './icon/trophy.png';

const TrophyMonitor = ({categoryColor, label, value}) => (
    <div className={styles.themeMonitor}>
         <img src={trophy} className={styles.themeMonitorIcon}/>
         <div className={styles.themeMonitorVbg}>
            <div className={styles.themeMonitorValue}>{value}</div>
         </div>
    </div>
);

TrophyMonitor.propTypes = {
    categoryColor: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default TrophyMonitor;
